/*
    Core store module actions
*/

import * as temp from "./temp";

export default {
  ...temp,
}
